import React from 'react';
import AtlasV2BasicKeyMetricsCards from 'src/components/AtlasV2Components/KeyMetricsComponents/AtlasV2BasicKeyMetricsCards';
import AtlasV2KeyMetricsCards from 'src/components/AtlasV2Components/KeyMetricsComponents/AtlasV2KeyMetricsCards';
import AtlasV2KeyMetricsGrid from 'src/components/AtlasV2Components/KeyMetricsComponents/AtlasV2KeyMetricsGrid';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { onPrimeMode } from 'src/store/modules/user/selectors';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * The first group of visualizations on the Key Metrics page for Atlas V2
 * @returns a component that renders the legend, key metric cards, and key metric grid
 */
export const AtlasV2KeyMetricsPageLayout = () => {
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  const mainEntityType = useMainEntityType();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      {onPrimeMode() ? <AtlasV2KeyMetricsCards /> : <AtlasV2BasicKeyMetricsCards />}

      {mainEntityType !== 'product' && <AtlasV2KeyMetricsGrid />}
    </BasePageContainer>
  );
};
